module.exports = __webpack_public_path__ + "static/img/11.67019f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/11.png
// module id = rJUw
// module chunks = 0